export default ({name, address1, address2, address3, town, postcode, telephone}) => 
`<div class="Member">
  <h3 class="Member-title">${name}</h3>
  <address class="Member-address">
    ${[address1, address2, address3].filter(x => !!x).join(", ")}
    <br />${town}
    <br />${postcode}
  </address>
  <a href="tel:${telephone}" class="Member-tel">${telephone}</a>
</div>`


// WEBPACK FOOTER //
// ./scripts/templates/member.js